"use client";

/* "use client" DITAMBAHKAN. useLanguage() memakai React Context, dan
   Context hanya hidup di browser - komponen yang membacanya wajib jadi
   Client Component. Lihat catatan sama di Footer.jsx. */

import { useLanguage } from "../i18n/LanguageProvider";

/* ============================================================
   CONTACT BANNER

   >>> WAJIB DIPERIKSA SEBELUM TAYANG: seluruh nomor di daftar KONTAK. <<<

   DUA TUJUAN BERBEDA DALAM SATU BARISAN KARTU:
     Telepon Utama     -> tel:, membuka aplikasi telepon
     Customer Service  -> wa.me, membuka chat WhatsApp
     Komplain Layanan  -> wa.me, membuka chat WhatsApp

   Pembagian itu mengikuti sifat nomornya, bukan selera. (021) 798 0888
   adalah nomor tetap alias landline; nomor tetap pada umumnya TIDAK
   terdaftar di WhatsApp, jadi memaksanya ke wa.me hampir pasti berujung
   halaman error. Dua nomor lainnya nomor seluler, dan di situlah
   WhatsApp masuk akal.

   NOMOR DITULIS SEKALI SAJA, di kolom `nomor`, dalam format
   internasional tanpa tanda baca: 62 + nomor tanpa 0 di depan.
     (021) 798 0888  ->  "62217980888"
     0811 901 874    ->  "62811901874"
     0815 801 7000   ->  "628158017000"
   Dari satu nilai itu tautan tel: maupun wa.me dibentuk otomatis. Yang
   tampil di layar tetap `label`, karena format enak dibaca dan format
   yang dimengerti mesin memang berbeda.

   TOLONG COCOKKAN SATU PER SATU dengan daftar nomor resmi RS. Tautan
   yang salah lebih buruk daripada tidak ada tautan sama sekali: orang
   menekan tombol, merasa sudah menghubungi rumah sakit, lalu tersambung
   ke nomor yang keliru atau tidak tersambung sama sekali.

   ⚠️ KHUSUS DUA KARTU WHATSAPP: wa.me tidak memeriksa apakah nomornya
   benar-benar terdaftar di WhatsApp. Kalau tidak, pengunjung keluar
   dari situs dan mendarat di halaman error WhatsApp tanpa diberi jalan
   lain. Uji dulu di ponsel - buka wa.me/62811901874 dan
   wa.me/628158017000 - lalu set `wa: false` untuk nomor mana pun yang
   menolak. Kartunya otomatis kembali jadi panggilan telepon, lengkap
   dengan ikon gagang telepon.

   ============================================================
   PERUBAHAN DARI VERSI SEBELUMNYA

   1. NOMOR JADI TAUTAN AKTIF. Ini perubahan terpenting dan satu-
      satunya yang bersifat fungsional. Sebelumnya nomor ditulis sebagai
      <p> biasa - di ponsel pengunjung harus menyalinnya manual.

      Karena kartunya kini benar-benar bisa ditekan, cursor-pointer di
      sini JUJUR - berbeda dengan kartu di section Fasilitas dan Kenapa
      Kami yang sengaja tidak diberi kursor jari.

      IKON TIAP KARTU MENGIKUTI TUJUANNYA: gagang telepon untuk tel:,
      gelembung chat untuk WhatsApp. Ikon yang menjanjikan satu hal lalu
      membuka hal lain adalah alasan pertama orang ragu menekan.

   2. TIGA NOMOR JADI TIGA KARTU BERJAJAR, bukan tiga baris bertumpuk.
      Versi lama menampilkan ketiganya dengan bobot visual yang persis
      sama, padahal perannya berbeda: satu nomor sentral, satu untuk
      pertanyaan, satu untuk keluhan. Kartu terpisah membuat pengunjung
      bisa memilih tanpa membaca ketiganya lebih dulu.

   3. JUDUL JADI PUTIH, aksen kuning pindah ke eyebrow di atasnya.
      Kuning di atas plum terang bermasalah, dan ini SUDAH DITANGANI:
      ujung terang gradien dihentikan di #15804a, bukan diteruskan ke
      #1e9a5b. Di #1e9a5b kuning #f2cd34 hanya mencapai 3,68:1 - gagal
      ambang 4,5:1 untuk teks berukuran normal. Di #15804a ia 5,07:1.
      KALAU GRADIENNYA DITERUSKAN LEBIH TERANG, eyebrow kuning ini harus
      diganti putih.

   4. MOTIF BATIK DIREDUPKAN dari opacity-30 ke opacity-20. Di versi
      lama motifnya masih terbaca jelas di belakang teks. Tekstur latar
      seharusnya terasa, bukan terbaca.

   5. <section> DIGANTI <div>. Di page.jsx komponen ini sudah dibungkus
      <section id="kontak">, jadi sebelumnya ada section di dalam section.

   ============================================================
   TIGA EFEK SAAT KURSOR MENDEKAT - berbeda dari dua section lain

   Fasilitas   : sudut berpindah, garis tepi menyala, foto membesar.
   Kenapa Kami : garis menggambar, ikon terangkat, teks bergeser.
   Di sini     : latar tersapu naik, ikon bergeser, label memutih.

   1. LATAR TERSAPU NAIK DARI BAWAH. Bidang terang tumbuh dari tepi
      bawah kartu ke atas, 400ms. Gerakannya vertikal, tidak dipakai di
      tempat lain.

      Dikerjakan dengan scale-y pada lapisan terpisah, bukan mengubah
      warna latar kartu. Transformasi dijalankan kartu grafis; mengubah
      warna latar memaksa browser menggambar ulang seluruh bidang.

   2. IKON BERGESER KE KANAN. Ini isyarat "menuju ke suatu tempat", dan
      di sini isyarat itu benar - kartunya memang membawa pengunjung
      keluar, ke aplikasi telepon atau ke WhatsApp.

   3. LABEL PERAN MEMUTIH dari #def2e8 ke putih penuh.

   Nomornya sendiri tidak diberi efek apa pun. Ia informasi yang mungkin
   sedang dibaca atau disalin orang, dan teks yang bergerak saat kursor
   lewat mengganggu pembacaan.

   ============================================================
   CATATAN TEKS

   Label nomor ketiga diringkas dari "Komplain - HP Complain untuk
   Service Kurang Baik" menjadi "Komplain Layanan". Versi lama mengulang
   kata komplain dua kali dalam dua bahasa, dan "untuk Service Kurang
   Baik" meminta pengunjung menilai lebih dulu apakah layanan yang ia
   terima cukup buruk untuk pantas dilaporkan - itu menaikkan ambang
   orang untuk bersuara.

   Kata "(Hunting)" pada nomor pertama juga dihapus dari tampilan. Itu
   istilah teknis telekomunikasi - nomor yang otomatis mengalihkan ke
   saluran kosong berikutnya - dan tidak berarti apa-apa bagi pasien.

   Kalau kamu ingin mengembalikan teks aslinya, ubah field `role` dan
   `note` di daftar KONTAK di bawah. Nomornya tidak perlu disentuh.
   ============================================================ */

/* `wa: true`  -> kartu membuka chat WhatsApp
   `wa: false` -> kartu membuka aplikasi telepon

   `sapaan` = kalimat yang sudah terketik di kolom chat saat WhatsApp
   terbuka, disesuaikan dengan peran tiap kartu. Kalimatnya sengaja
   dibuat UTUH, bukan template menggantung seperti "Saya ingin bertanya
   tentang:", karena sebagian besar orang menekan kirim tanpa mengubah
   apa pun - dan petugas akan menerima kalimat setengah jadi.

   Kartu Telepon Utama tidak punya `sapaan` dan memang tidak perlu:
   kolom itu hanya dibaca kalau `wa` bernilai true. */
const KONTAK = [
  { roleKey: "banner.utama", noteKey: "banner.utamaNote", label: "(021) 798 0888", nomor: "62217980888", wa: false },
  { roleKey: "banner.cs", noteKey: "banner.csNote", label: "0811 901 874", nomor: "62811901874", wa: true, sapaanKey: "banner.csSapaan" },
  { roleKey: "banner.komplain", noteKey: "banner.komplainNote", label: "0815 801 7000", nomor: "628158017000", wa: true, sapaanKey: "banner.komplainSapaan" },
];

function IkonTelepon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" className="h-5 w-5 md:h-6 md:w-6">
      <path
        d="M6.5 3h3l1.5 4-2 1.5a12 12 0 0 0 6.5 6.5L17 13l4 1.5v3a2 2 0 0 1-2.2 2A17 17 0 0 1 4 5.2 2 2 0 0 1 6 3Z"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function IkonChat() {
  return (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" className="h-5 w-5 md:h-6 md:w-6">
      <path
        d="M20.5 11.5a7.8 7.8 0 0 1-8.5 7.8 9 9 0 0 1-2.6-.4L4.5 20.5l1.3-4.2a7.6 7.6 0 0 1-1.3-4.3 7.8 7.8 0 0 1 8-7.5 7.8 7.8 0 0 1 8 7Z"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default function ContactBanner() {
  const { t } = useLanguage();

  return (
    <div className="relative overflow-hidden bg-gradient-to-r from-[var(--c-brand)] via-[var(--c-brand-mid)] to-[var(--c-brand-mid)] px-4 py-14 sm:px-6 sm:py-16 md:py-20 lg:px-10">

      <div aria-hidden="true" className="absolute inset-0 opacity-20">
        <svg className="h-full w-full">
          <defs>
            <pattern id="batikPattern" width="50" height="50" patternUnits="userSpaceOnUse">
              <path
                d="M25 0 Q40 12 25 25 Q10 12 25 0 M25 25 Q40 38 25 50 Q10 38 25 25"
                fill="none"
                stroke="#ffffff"
                strokeWidth="1.2"
                opacity="0.4"
              />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#batikPattern)" />
        </svg>
      </div>

      <div className="relative z-10 mx-auto max-w-[1600px]">

        <div className="mb-8 text-center sm:mb-10 md:mb-14">
          <p className="mb-2 text-[11px] font-semibold uppercase tracking-[0.16em] text-[var(--c-on-brand-3)] sm:mb-3 sm:text-xs sm:tracking-[0.18em] md:text-sm">
            {t("banner.eyebrow")}
          </p>

          <h2 className="text-balance text-2xl font-bold leading-[1.15] tracking-tight text-white sm:text-3xl md:text-4xl">
            {t("banner.judul")}
          </h2>
        </div>

        <div className="mx-auto grid max-w-md gap-3 sm:gap-4 md:max-w-none md:grid-cols-3 md:gap-5 lg:gap-6">
          {KONTAK.map((item) => {
            const role = t(item.roleKey);
            const sapaan = item.sapaanKey ? t(item.sapaanKey) : "";

            const href = item.wa
              ? `https://wa.me/${item.nomor}${
                  sapaan ? `?text=${encodeURIComponent(sapaan)}` : ""
                }`
              : `tel:+${item.nomor}`;

            const luar = item.wa
              ? { target: "_blank", rel: "noopener noreferrer" }
              : {};

            const aria = item.wa
              ? t("banner.waAria", { peran: role, nomor: item.label })
              : t("banner.telAria", { peran: role, nomor: item.label });

            const Ikon = item.wa ? IkonChat : IkonTelepon;

            return (
            <a
              key={item.nomor}
              href={href}
              aria-label={aria}
              {...luar}
              className="group relative isolate overflow-hidden rounded-2xl bg-white/10 p-5 ring-1 ring-white/20 transition-shadow duration-300 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white sm:p-6 md:rounded-[20px] md:p-7"
            >
              <span
                aria-hidden="true"
                className="absolute inset-0 -z-10 origin-bottom scale-y-0 bg-white/15 transition-transform duration-[400ms] ease-out group-hover:scale-y-100 motion-reduce:transition-none"
              />

              <div className="mb-3 flex items-center gap-3 md:mb-4">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-[var(--c-brand-strong)]/60 text-[var(--c-on-brand-3)] ring-1 ring-white/20 transition-transform duration-300 ease-out group-hover:translate-x-1 motion-reduce:transition-none motion-reduce:group-hover:translate-x-0 md:h-12 md:w-12">
                  <Ikon />
                </span>

                <span className="text-sm font-bold text-[var(--c-on-brand-2)] transition-colors duration-300 group-hover:text-white motion-reduce:transition-none md:text-base">
                  {role}
                </span>
              </div>

              <p className="mb-2 text-xl font-bold tabular-nums text-white sm:text-2xl md:text-[26px]">
                {item.label}
              </p>

              <p className="text-[13px] leading-relaxed text-[var(--c-on-brand-1)]/75 sm:text-sm">
                {t(item.noteKey)}
              </p>
            </a>
            );
          })}
        </div>

      </div>
    </div>
  );
}
